/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { Icon } from '@plone/volto/components';
import { Link, useLocation } from 'react-router-dom';

import globeSVG from '@plone/volto/icons/globe.svg';
import emailSVG from '@plone/volto/icons/email.svg';
import phoneSVG from '@plone/volto/icons/mobile.svg';
import facebookSVG from 'volto-proseriestools/icons/facebook.svg';
import instagramSVG from 'volto-proseriestools/icons/instagram.svg';
import youtubeSVG from 'volto-proseriestools/icons/youtube.svg';

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = () => {
  const pathname = useLocation().pathname;
  return pathname === '/' ? (
    <div id="footer">
      <div className="full-width top">
        <Container>
          <Grid stackable columns={12}>
            <Grid.Column
              largeScreen={4}
              widescreen={4}
              computer={4}
              tablet={12}
              mobile={12}
            >
              <span className="header">Pro Series Tools</span>
              <div className="list">
                <div className="item">36 Road 5243</div>
                <div className="item">Farmington, NM 87401</div>
                <div className="item">United States</div>
              </div>
            </Grid.Column>
            <Grid.Column
              largeScreen={4}
              widescreen={4}
              computer={4}
              tablet={12}
              mobile={12}
            >
              <span className="header">Follow Us</span>
              <div className="list">
                <div className="item">
                  <a
                    href="https://facebook.com/proseriestools"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon name={facebookSVG} size="14px" />
                    Facebook
                  </a>
                </div>
                <div className="item">
                  <a
                    href="https://instagram.com/proseriestools"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon name={instagramSVG} size="14px" />
                    Instagram
                  </a>
                </div>
                <div className="item">
                  <a
                    href="https://youtube.com/@proseriestools"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon name={youtubeSVG} size="14px" />
                    YouTube
                  </a>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column
              largeScreen={4}
              widescreen={4}
              computer={4}
              tablet={12}
              mobile={12}
            >
              <span className="header">Contact</span>
              <div className="list">
                <div className="item">
                  <Icon name={phoneSVG} size="16px" />
                  <a href="tel:+15056327039">+1 (505) 632-7039</a>
                </div>
                <div className="item">
                  <Icon name={emailSVG} size="14px" />
                  <a href="mailto:info@proseriesleathertools.com">
                    info@proseriesleathertools.com
                  </a>
                </div>
                <div className="item">
                  <Icon name={globeSVG} size="14px" />
                  <a href="https://proseriesleathertools.com">
                    https://proseriesleathertools.com
                  </a>
                </div>
              </div>
            </Grid.Column>
          </Grid>
        </Container>
      </div>
      <div className="full-width bottom">
        <Container>
          <Grid stackable stretched columns={12}>
            <Grid.Column
              largeScreen={6}
              widescreen={6}
              computer={6}
              tablet={12}
              mobile={12}
            >
              <div className="copyright">
                Copyright &copy; {new Date().getFullYear()} Pro Series Tools
                LLC. All rights reserved.
              </div>
            </Grid.Column>
            <Grid.Column
              largeScreen={6}
              widescreen={6}
              computer={6}
              tablet={12}
              mobile={12}
            >
              <div className="legal">
                <Link to="/privacy-policy">Privacy Policy</Link> |{' '}
                <Link to="/terms-of-service">Terms of Service</Link>
              </div>
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    </div>
  ) : (
    ''
  );
};

export default Footer;
